<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" [style]="nestedPadding$ | async">
        <sh-field-label
            [label]="profileField.DisplayLabel ? profileField.DisplayLabel : profileField.FieldDefinition.Label"
            [labelIcons]="labelIcons"
        ></sh-field-label>
        <span *ngIf="index !== undefined">{{ index + 1 }}</span>
    </dt>
    @if (locationFieldDefinition$ | async; as fieldDefinition) {
        <dd *ngIf="value$ | async as value; else emptyData" class="sh-description-list__details">
            <span class="sh-icon-label">
                <ng-container
                    *ngTemplateOutlet="
                        canSearchOnClick(fieldDefinition) ? searchableData : nonSearchableData;
                        context: { value: value, fieldDefinition: fieldDefinition }
                    "
                >
                </ng-container>
            </span>
            <button
                *ngIf="record$ | async as fragment"
                class="sh-link sh-icon-link openDialogButton"
                (click)="openLocationDialog(fragment, profileField.FieldDefinition)"
            >
                {{ "modules.general.form.location.show-map-location" | translate }}
                <svg sh-icon class="sh-icon-link__icon" aria-hidden="true" [name]="'angle-right'"></svg>
            </button>

            <button
                *ngIf="record$ | async as record"
                class="sh-link sh-icon-link openDialogButton"
                [title]="'modules.general.form.location.show-all-subfields' | translate"
                (click)="openSubFieldDialog(record, profileField, value, fieldDefinition)"
            >
                {{ "modules.general.form.location.show-all-subfields" | translate }}
                <svg sh-icon class="sh-icon-link__icon" aria-hidden="true" [name]="'angle-right'"></svg>
            </button>
        </dd>
    }
</ng-container>

<ng-template #searchableData let-value="value" let-fieldDefinition="fieldDefinition">
    <span class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)">{{ value }}</span>
</ng-template>

<ng-template #nonSearchableData let-value="value">
    <span>{{ value }}</span>
</ng-template>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
